import { render, staticRenderFns } from "./Email-sella-transaction.vue?vue&type=template&id=c4cff49e"
import script from "./Email-sella-transaction.vue?vue&type=script&lang=js"
export * from "./Email-sella-transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports